<div class="tab-container" role="tablist">
  @for (tab of tabList; track $index; let i = $index) {
    <button
      [ngClass]="{ active: tab.isActive }"
      (click)="tabClick(i)"
      role="tab"
      type="button"
      [attr.aria-selected]="tab.isActive"
      [attr.aria-label]="tab.label"
    >
      @if (tab.icon) {
        <i class="pi" [ngClass]="tab.icon"></i>
      }
      {{ tab.label }}
    </button>
  }
</div>
